module.exports = __webpack_public_path__ + "static/media/Stellar Ace Single Headboard - 120 cm.f1fb979c.jpg";